// third-party
import { combineReducers } from 'redux';

// project-imports
import chat from './chat';
import channel from './channel';

import menu from './menu';
import snackbar from './snackbar';
import socket from './socket';
import auth from './auth';
import tags from './tags';
import users from './users';
import profiles from './profiles';
import attendanceSettings from './attendanceSettings';
import notificationSettings from './notificationSettings';
import auditLog from './auditLog';
import campaigns from './campaigns';
import departaments from './departaments';
import soundReducer from './soundSlice';
import reports from './reports';
import community from './community';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  chat,
  channel,
  users,
  tags,
  profiles,
  attendanceSettings,
  notificationSettings,
  auditLog,
  departaments,
  campaigns,
  community,
  menu,
  snackbar,
  socket,
  auth,
  sound: soundReducer,
  reports
});

export default reducers;
